import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const SidebarContainer = styled.div`
  width: 200px;
  height: 100%;
  position: relative;
`;

export const SidebarWrapper = styled.div`
  width: 200px;
  height: 100%;
  background: ${prop => prop.background};
  position: fixed;

  a {
    display: block;
    padding: 10px 24px;
    text-decoration: none;
    border-left: solid ${colors.bgPrimary} 4px;
    transition: .2s;
  }

  a:hover {
    background:${colors.bgPrimaryLight};
    border-left: solid ${colors.textHyperlink} 4px;
  }

  a.active {
    background:${colors.bgPrimaryLight};
    border-left: solid ${colors.textHyperlink} 4px;
  }
`;

export const SidebarBrand = styled.div`
  padding: 26px 20px;
  
  a {
    padding: 0;
    border: none !important;
    background: none !important;
    margin-left: 20px;
    height: 10px;
  }
`;

export const SidebarDropdown = styled.div`
  margin: 16px 0;
  height: auto;
  transition: ease-in-out .2s;
`;

export const SidebarDropdownTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  cursor: pointer;

  svg {
    transform: ${prop => prop.open ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }
`;

export const SidebarDropdownLabel = styled.span`
  font-size: 10px;
  color: ${colors.white};
  text-transform: uppercase;
`;

export const SidebarDropdownLinks = styled.div`
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
  transition: opacity .2s ease-out;
`;
